import {publishEvent} from './services/analytics/pub-sub';
import {ANALYTIC_EVENTS} from './services/analytics/pub-sub/constants';

const initMobileBottomNavigationAnalytics = () => {
  const navigationLinkElement = document.querySelector('.js-mobile-bottom-navigation');

  if (!navigationLinkElement) {
    return;
  }

  navigationLinkElement.addEventListener('click', event => {
    const linkElement = event.target.closest('a');
    const eventTarget = linkElement?.dataset?.eventTarget;

    if (eventTarget) {
      publishEvent(ANALYTIC_EVENTS.MOBILE_BOTTOM_NAVIGATION_TAP, {
        eventTarget
      });
    }
  });
};

initMobileBottomNavigationAnalytics();
